export default "__VITE_ASSET__Dspqxh68__"